var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserCircleGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33334 28C4.33334 14.7452 15.0785 4 28.3333 4C41.5882 4 52.3333 14.7452 52.3333 28C52.3333 41.2548 41.5882 52 28.3333 52C15.0785 52 4.33334 41.2548 4.33334 28Z",
    fill: "#D1FADF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3333 37V35C36.3333 33.9391 35.9119 32.9217 35.1618 32.1716C34.4116 31.4214 33.3942 31 32.3333 31H24.3333C23.2725 31 22.2551 31.4214 21.5049 32.1716C20.7548 32.9217 20.3333 33.9391 20.3333 35V37M32.3333 23C32.3333 25.2091 30.5425 27 28.3333 27C26.1242 27 24.3333 25.2091 24.3333 23C24.3333 20.7909 26.1242 19 28.3333 19C30.5425 19 32.3333 20.7909 32.3333 23Z",
    stroke: "#039855",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 48C17.2876 48 8.33334 39.0457 8.33334 28H0.333344C0.333344 43.464 12.8694 56 28.3333 56V48ZM48.3333 28C48.3333 39.0457 39.379 48 28.3333 48V56C43.7973 56 56.3333 43.464 56.3333 28H48.3333ZM28.3333 8C39.379 8 48.3333 16.9543 48.3333 28H56.3333C56.3333 12.536 43.7973 0 28.3333 0V8ZM28.3333 0C12.8694 0 0.333344 12.536 0.333344 28H8.33334C8.33334 16.9543 17.2876 8 28.3333 8V0Z",
    fill: "#ECFDF3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircleGreen);
export default __webpack_public_path__ + "static/media/user-circle-green.228f2e39.svg";
export { ForwardRef as ReactComponent };